import React from "react";
import styled from "styled-components";

export const subjectCategories = {
  science: [["physics", "物理"], ["chemistry", "化學"], ["biology", "生物"], ["earth_science", "地科"], ["integrated", "跨領域"]],
  social: [["history", "歷史"], ["geography", "地理"], ["civics", "公民"], ["integrated", "跨領域"]],
};

export default function QuestionCategorySelect({ subject, value = "", onChange, filter = false, label = "分類" }) {
  const options = subjectCategories[subject];
  if (!options) return null;
  if (filter) return <CategoryFilter aria-label="科目分類">
    <legend>科目分類</legend>
    <CategoryButtons>
      {[["", "全部分類"], ...options, ["unassigned", "未分類"]].map(([id, name]) =>
        <button key={id} type="button" aria-pressed={value === id} onClick={() => onChange(id)}>{name}</button>)}
    </CategoryButtons>
  </CategoryFilter>;
  return <label>{label}
    <select aria-label={label} value={value} onChange={(event) => onChange(event.target.value)}>
      <option value="">{filter ? "全部分類" : "未分類"}</option>
      {filter && <option value="unassigned">未分類</option>}
      {options.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
    </select>
  </label>;
}

const CategoryFilter = styled.fieldset`
  grid-column: 1 / -1;
  flex: 1 0 100%;
  min-width: 0;
  margin: 0 0 4px;
  padding: 12px 14px 14px;
  border: 1px solid var(--app-border, #dbe4ed);
  border-radius: 14px;
  background: var(--app-surface, #f5f8fc);
  legend {
    padding: 0 6px;
    font-size: 13px;
    font-weight: 700;
    color: var(--app-text, #334155);
  }
`;
const CategoryButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  button {
    min-height: 38px;
    padding: 8px 16px;
    border: 1px solid var(--app-border, #ccd8e5);
    border-radius: 10px;
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    color: var(--app-text, #334155);
    background: var(--app-surface, #fff);
    cursor: pointer;
  }
  button:hover { border-color: #507eac; }
  button[aria-pressed="true"] { background: #153f67; color: #fff; border-color: #153f67; }
  button:focus-visible { outline: 3px solid #e6ab4b; outline-offset: 2px; }
  @media (max-width: 600px) {
    gap: 6px;
    button { flex: 1 0 auto; padding: 8px 12px; }
  }
  [data-auth-theme="night"] & button[aria-pressed="true"] {
    background: var(--app-nav-active-bg, #4a4a4a);
    border-color: var(--app-subtle-text, #bebebe);
    color: var(--app-nav-active-text, #eeeeee);
  }
`;
